import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_wrkrs_have_the_right_to_consult_w_and_be_represented_either'

export const dataPointDefinition = {
  retracedId: 'do_wrkrs_have_the_right_to_consult_w_and_be_represented_either',
  name: 'Do workers have the right to consult with and be represented either by a trade union or by worker representatives when evaluating and contesting disciplinary decisions?',
  description:
    'In the event a disciplinary action is taken, the intent of this question is to understand if workers have the right to consult with (and be represented) either by a trade union or by worker representatives.\r\r\n\r\r\nFor example, if there is a trade union onsite, but workers are not able to be represented by trade union officials regarding disciplinary actions that have been taken against them, answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'discp-5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11590,
  sectionId: '2.2.4.4',
  impactArea: 'Discipline',
  impactAreaId: 'DISCIPLINE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
